export default __webpack_public_path__ + "static/media/react.7cba2c46.svg";